import ProfileDropdown from "./ProfileDropdown";
import './profileDropdown.scss';

export default ProfileDropdown;